export const DIGITAL_WELL_BEING_PRODUCT_NAME = 'digital-well-being'
export const UNIT_ROUTE_PRODUCT_NAMES = [
  'elementary',
  'middle-school',
  DIGITAL_WELL_BEING_PRODUCT_NAME,
]
